import script from "./EstuariosView.vue?vue&type=script&setup=true&lang=js"
export * from "./EstuariosView.vue?vue&type=script&setup=true&lang=js"

import "./EstuariosView.vue?vue&type=style&index=0&id=538fa4a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-538fa4a2"]])

export default __exports__